import FooterPage from "../components/Custom/Footer/FooterPage";
import Navbar from "../components/Custom/Navbar/Navbar";
import Accounts from "../components/PayMethods/Accounts/Accounts";

export default function PayMethods() {
  return (
    <>
      <Navbar />
      <Accounts />
      <FooterPage />
    </>
  );
}
